export function isLinkActive(pathname: string, url: string): boolean {
  if (!url) return false;
  if (url === "/") return pathname === "/";
  return pathname === url || pathname.startsWith(`${url}/`);
}
